import { render } from "./AddDocumentsView.vue?vue&type=template&id=72adb7d4&scoped=true&ts=true"
import script from "./AddDocumentsView.vue?vue&type=script&lang=ts"
export * from "./AddDocumentsView.vue?vue&type=script&lang=ts"

import "./AddDocumentsView.vue?vue&type=style&index=0&id=72adb7d4&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72adb7d4"]])

export default __exports__